import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { EventLog, PentaDashboard } from '@volvogroup-internal/dashboard';
import { useTranslation } from 'react-i18next';

import { getToken } from '@/config/MsalAuthConfig';
import { client } from '@/service/vpc/vpcService';

export const Route = createFileRoute('/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/diagnostics/')({
  component: DiagnosticsPage,
});

export function DiagnosticsPage() {
  const { endCustomerUnitId } = useParams({
    strict: false,
  });
  const { i18n } = useTranslation();
  const queryClient = useQueryClient();

  return (
    <PentaDashboard
      client={{
        httpClient: {
          instance: client,
          getToken: getToken,
        },
        queryClient,
      }}
      language={i18n.language}
      preFilterUnits={[Number(endCustomerUnitId!)]}
      showFilterBar
    >
      <EventLog endCustomerUnitId={Number(endCustomerUnitId!)} mainSegment="Marine" canSeeRemoteReadoutButton={true} />
    </PentaDashboard>
  );
}
